import { render, staticRenderFns } from "./ServiceWorkForm.vue?vue&type=template&id=c831750c&"
import script from "./ServiceWorkForm.vue?vue&type=script&lang=js&"
export * from "./ServiceWorkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports